<template>
  <gg-card>
    <gg-card-header>
      Currently-Blocked IP Addresses
    </gg-card-header>
    <gg-card-text>
      <v-data-table :headers="headers" :items="items" :loading="pending">
        <template v-slot:item.actions="{ item }">
          <gg-btn @click="triggerModal(item.ip)">
            Delete
          </gg-btn>
        </template>
      </v-data-table>
      <gg-modal :is-active="dialog" @close="triggerModal">
        <template v-slot:toolbar>Remove IP</template>
        <template v-slot:body>Are you certain that you wish to delete the IP address “{{ ipToRemove }}”?</template>
        <template v-slot:actions>
          <gg-btn secondary @click.prevent="triggerModal">Cancel</gg-btn>
          <gg-btn primary :loading="dialogPending" @click="removeIp">Remove IP</gg-btn>
        </template>
      </gg-modal>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BlockedIpTable',
  data: () => ({
    headers: [
      { text: 'Server Setting', align: 'left', value: 'ip' },
      { text: 'Beginning IP', align: 'left', value: 'start' },
      { text: 'Ending IP', align: 'left', value: 'end' },
      { text: 'Actions', align: 'left', value: 'actions' },
    ],
    dialog: false,
    pending: false,
    dialogPending: false,
    ipToRemove: ''
  }),
  computed: {
    ...mapGetters({
      items: 'hosting_security/ipList'
    })
  },
  created () {
    this.getData()
  },
  methods: {
    ...mapActions({
      getIpList: 'hosting_security/getIpList',
      removeIpFromBlackList: 'hosting_security/removeIpFromBlackList',
      reportError: 'reportError'
    }),
    async getData () {
      try {
        this.pending = true
        await this.getIpList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    },
    async removeIp () {
      try {
        this.dialogPending = true
        await this.removeIpFromBlackList({ ip: this.ipToRemove, _username: this.$route.query.user })
        this.triggerModal()
        await this.getData()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.dialogPending = false
      }
    },
    triggerModal (ip = '') {
      this.dialog = !this.dialog
      if (typeof ip !== 'string') {
        this.ipToRemove = ''
      } else {
        this.ipToRemove = ip
      }
    }
  }
}
</script>

<style scoped>

</style>
